import styled from 'react-emotion';

const Button = styled.button`
  display: block;
  color: #ffffff;
  background: none;
  line-height: 1.4;
  text-align: center;

  &:hover,
  &:focus,
  &.active {
    outline: none;
  }
`;


export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-width: 100%;
`;

export const TextButton = styled(Button)`
  font-size: 28px;
  height: 80px;
  width: 160px;
  background-color: rgb(34, 167, 240);
  border: none;
  border-radius: 5px;
  flex-shrink: 0;
  flex-grow: 0;
  white-space: nowrap;
  padding: 0px !important;
  &:disabled {
    background: #c0c0c0;
  }
`;

export const HighLightedButton = styled(TextButton)`
  height: 50px;
  border-radius: 25px;
`;

export const LargeButton = styled(TextButton)`
  font-size: 36px;
  height: 88px;
  width: 600px;
  background: none;
  margin: 30px auto;
  border: 1px solid white;
  
  &:first-of-type {
    margin-top: 0;
  }
`;

export const LargePrimaryButton = styled(LargeButton)`
  color: white;
  background: #22a7f0;
`;

export const WhiteLargePrimaryButton = styled(LargeButton)`
  background: white;
  color: rgb(34, 167, 240);
  &:disabled {
    background: white;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/button.jsx